import * as showdown from 'showdown'

const s = showdown
s.setFlavor('github')


export default new showdown.Converter({
	literalMidWordUnderscores: true
});